import { push } from 'react-router-redux';
import _ from 'lodash';
// import GoogleMapsLoader from 'google-maps';

import {
  getBuildings,
  getBuilding,
  getDemographics,
  getPropertyFilterValues,
  getSites,
  getSite,
  getViewerCustomizations,
} from '../ajax/endpoints';

import { railroads } from '../config';

import { PROPERTY_TYPES, LAZY_DEFAULTS } from '../constants';

export function activateMapLoadingStatus() {
  return {
    type: 'ACTIVATE_MAP_LOADING',
  };
}
export function deactivateMapLoadingStatus() {
  return {
    type: 'DEACTIVATE_MAP_LOADING',
  };
}

export function activateListLoadingStatus() {
  return {
    type: 'ACTIVATE_LIST_LOADING',
  };
}
export function deactivateListLoadingStatus() {
  return {
    type: 'DEACTIVATE_LIST_LOADING',
  };
}

function filtersToFindParam(map) {
  const find = [...map].reduce((obj, item) => {
    // Search has own parameter
    if (item[0] === 'search') {
      return obj;
    } else if (item[0] === 'area') {
      return {
        ...obj,
        area: {
          layer: item[1].layer,
          ids: (item[1].layer === 'regions')
            ? item[1].counties.map(c => c.id)
            : [item[1].id],
        },
      };
    }
    return {
      ...obj,
      [item[0]]: item[1],
    };
  }, {});
  return JSON.stringify(find);
}

function sortToParam(sort) {
  const [key, direction] = sort;

  const sortParam = {
    [key]: direction === 'low' ? 1 : -1,
  };
  return JSON.stringify(sortParam);
}

export function setViewerPolygon(polygon) {
  return {
    type: 'SET_VIEWER_POLYGON',
    polygon,
  };
}

export function activateModal(name, properties) {
  return {
    type: 'ACTIVATE_MODAL',
    name,
    properties,
  };
}

export function deactivateModal() {
  return {
    type: 'DEACTIVATE_MODAL',
  };
}

export function activateMeasure() {
  return {
    type: 'ACTIVATE_MEASURE',
  };
}

export function deactivateMeasure() {
  return {
    type: 'DEACTIVATE_MEASURE',
  };
}

export function addBuildings(buildings) {
  return {
    type: 'ADD_BUILDINGS',
    buildings,
  };
}

export function addMoreBuildings(buildings) {
  return {
    type: 'ADD_MORE_BUILDINGS',
    buildings,
  };
}

export function addActiveBuilding(building) {
  return {
    type: 'ADD_ACTIVE_BUILDING',
    building,
  };
}

export function addActiveBuildingArea(area) {
  return {
    type: 'ADD_ACTIVE_BUILDING_AREA',
    area,
  };
}

export function addActiveBuildingAreaPolygon(layer, area, polygons) {
  return {
    type: 'ADD_ACTIVE_BUILDING_AREA_POLYGON',
    layer,
    area,
    polygons,
  };
}

export function addBuildingAreaDetails(details, layer) {
  return {
    type: 'ADD_BUILDING_AREA_DETAILS',
    details,
    layer,
  };
}

export function addBuildingAreaReport(report, layer) {
  return {
    type: 'ADD_BUILDING_AREA_REPORT',
    report,
    layer,
  };
}

export function addActiveBuildingDemographics(demographics) {
  return {
    type: 'ADD_ACTIVE_BUILDING_DEMOGRAPHICS',
    demographics,
  };
}

export function addSites(sites) {
  return {
    type: 'ADD_SITES',
    sites,
  };
}

export function addMoreSites(sites) {
  return {
    type: 'ADD_MORE_SITES',
    sites,
  };
}

export function addActiveSite(site) {
  return {
    type: 'ADD_ACTIVE_SITE',
    site,
  };
}

export function addActiveSiteArea(area) {
  return {
    type: 'ADD_ACTIVE_SITE_AREA',
    area,
  };
}

export function addActiveSiteAreaPolygon(layer, area, polygons) {
  return {
    type: 'ADD_ACTIVE_SITE_AREA_POLYGON',
    layer,
    area,
    polygons,
  };
}

export function addSiteAreaDetails(details, layer) {
  return {
    type: 'ADD_SITE_AREA_DETAILS',
    details,
    layer,
  };
}

export function addSiteAreaReport(report, layer) {
  return {
    type: 'ADD_SITE_AREA_REPORT',
    report,
    layer,
  };
}

export function setPropertyFilterValues(values, type) {
  return {
    type: `ADD_${type.toUpperCase()}_FILTER_VALUES`,
    values,
  };
}

export function addActiveSiteDemographics(demographics) {
  return {
    type: 'ADD_ACTIVE_SITE_DEMOGRAPHICS',
    demographics,
  };
}

export function clearActiveBuilding() {
  return dispatch => {
    dispatch({
      type: 'CLEAR_ACTIVE_BUILDING',
    });
    dispatch(push(`/buildings${window.location.search}`));
  };
}

export function clearActiveSite() {
  return dispatch => {
    dispatch({
      type: 'CLEAR_ACTIVE_SITE',
    });
    dispatch(push(`/sites${window.location.search}`));
  };
}

export function addFavoriteBuildings(items) {
  return {
    type: 'ADD_FAVORITE_ITEMS',
    itemType: 'buildings',
    items,
  };
}

export function addFavoriteSites(items) {
  return {
    type: 'ADD_FAVORITE_ITEMS',
    itemType: 'sites',
    items,
  };
}

export function addHoveredProperty(property) {
  return {
    type: 'ADD_HOVERED_PROPERTY',
    property,
  };
}

export function clearHoveredProperty() {
  return {
    type: 'CLEAR_HOVERED_PROPERTY',
  };
}

export function updateFilter(area, filters) {
  return {
    type: `ADD_${area.toUpperCase()}_FILTER`,
    filters,
  };
}

export function removeFilter(area, filterName, previouslySearchedLayer) {
  return {
    type: `REMOVE_${area.toUpperCase()}_FILTER`,
    filterName,
    previouslySearchedLayer,
  };
}
export function addFilterDrawnLayer(area, layer) {
  return {
    type: `ADD_${area.toUpperCase()}_FILTER_DRAWN_LAYER`,
    layer,
  };
}
export function removeFilterDrawnLayer(area) {
  return {
    type: `REMOVE_${area.toUpperCase()}_FILTER_DRAWN_LAYER`,
  };
}

export function clearFilters(area) {
  return {
    type: `CLEAR_${area.toUpperCase()}_FILTERS`,
  };
}

export function handleFilter(visible, name) {
  if (visible) {
    const type = visible === 'open' ? 'OPEN_FILTER' : 'CLOSE_FILTER';
    return {
      type,
      name,
    };
  }
  return {
    type: 'TOGGLE_FILTER',
    name,
  };
}

export function handleSort(area, sort) {
  return {
    type: `SET_${area.toUpperCase()}_SORT`,
    sort,
  };
}

export function setOrganizationId(id) {
  return {
    type: 'SET_ORGANIZATION_ID',
    id,
  };
}

export function setPagination(propertyType, pagination) {
  return {
    type: `SET_${propertyType.toUpperCase()}_PAGINATION`,
    pagination,
  };
}

export function fetchPropertyFilterValues(org, type) {
  return dispatch => {
    return getPropertyFilterValues(org, type)
      .then(data => {
        if (Object.keys(data).length > 0) {
          dispatch(setPropertyFilterValues(data, type));
        }
        return data;
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function fetchFavoriteBuildings(org, params) {
  return dispatch => {
    return getBuildings(org, params, 0)
      .then(data => {
        // sort results by order defined in database folder storage
        try {
          const sortedIds = JSON.parse(params.find)._id;
          const sortedItems = [];
          sortedIds.forEach(sortedId => {
            sortedItems.push(data._items.filter(dataItem => dataItem._id === sortedId)[0]);
          });
          dispatch(addFavoriteBuildings(sortedItems));
        } catch (e) {
          // if anything goes wrong, fall back to previous behavior
          dispatch(addFavoriteBuildings(data._items));
        }
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function getViewerInitialResults(org) {
  if (org === 'abc123') {
    return Promise.resolve(LAZY_DEFAULTS.INITIAL);
  }
  return getViewerCustomizations(org)
    .then(orgProps => {
      return orgProps.viewer && orgProps.viewer.initialResults ? orgProps.viewer.initialResults
        : LAZY_DEFAULTS.INITIAL;
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error(err);
      return LAZY_DEFAULTS.INITIAL;
    });
}

export function fetchBuildings(org, params, page) {
  return dispatch => {
    dispatch(activateListLoadingStatus());
    return getViewerInitialResults(org)
      .then(initialResults => {
        return getBuildings(org, params, initialResults)
          .then(data => {
            const pagination = {
              count: data._count,
              page: data._page,
            };
            // If page already exists, query addMoreBuildings
            //    instead of reloading all original buildings.
            const dispatcher = page ? addMoreBuildings : addBuildings;
            dispatch(setPagination('buildings', pagination));
            dispatch(dispatcher(data._items, page));
            dispatch(deactivateListLoadingStatus());
          }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            dispatch(deactivateListLoadingStatus());
            return [];
          });
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function fetchFavoriteSites(org, params) {
  return dispatch => {
    return getSites(org, params, 0)
      .then(data => {
        // sort results by order defined in database folder storage
        try {
          const sortedIds = JSON.parse(params.find)._id;
          const sortedItems = [];
          sortedIds.forEach(sortedId => {
            sortedItems.push(data._items.filter(dataItem => dataItem._id === sortedId)[0]);
          });
          dispatch(addFavoriteSites(sortedItems));
        } catch (e) {
          // if anything goes wrong, fall back to previous behavior
          dispatch(addFavoriteSites(data._items));
        }
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function fetchSites(org, params, page) {
  return dispatch => {
    dispatch(activateListLoadingStatus());
    return getViewerInitialResults(org)
      .then(initialResults => {
        return getSites(org, params, initialResults)
        .then(data => {
          const pagination = {
            count: data._count,
            page: data._page,
          };
          const dispatcher = page ? addMoreSites : addSites;
          dispatch(setPagination('sites', pagination));
          dispatch(dispatcher(data._items, page));
          dispatch(deactivateListLoadingStatus());
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
          dispatch(deactivateListLoadingStatus());
          return [];
        });
      }).catch(err => {
          // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function fetchSite(id, isMobile, orgId) {
  return dispatch => {
    return getSite(id, orgId)
      .then(data => {
        dispatch(addActiveSite(data));
        return data;
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function fetchDemographics(coordinates, radii, type, minutesFlag) {
  const adder = type === PROPERTY_TYPES.BUILDINGS
    ? addActiveBuildingDemographics
    : addActiveSiteDemographics;
  return dispatch => {
    return getDemographics(coordinates, radii, minutesFlag)
      .then(demographics => {
        dispatch(adder(demographics));
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function setDemographic(type, field) {
  return {
    type: `SET_${type.toUpperCase()}_DEMOGRAPHIC`,
    field,
  };
}

export function setWorkforce(type, isActive) {
  return {
    type: `SET_${type.toUpperCase()}_WORKFORCE`,
    isActive,
  };
}

export function deactivateWorkforce() {
  return {
    type: 'DEACTIVATE_WORKFORCE',
  };
}

export function setSelectedWorkforceMeasure(measure) {
  return {
    type: 'SET_WORKFORCE_MEASURE',
    measure,
  };
}

export function setActiveDrawing(shape) {
  return {
    type: 'SET_ACTIVE_DRAWING',
    shape,
  };
}

export function setCustomLayer(type, layer) {
  return {
    type: `SET_${type.toUpperCase()}_CUSTOM_LAYER`,
    layer,
  };
}

export function setSearchCustomLayerForPropertyType(type, layer, previouslySearchedLayer) {
  return {
    type: `SET_${type.toUpperCase()}_SEARCH_CUSTOM_LAYER`,
    layer,
    previouslySearchedLayer,
  };
}

export function setSearchCustomLayer(layer) {
  return {
    type: 'SAVE_SEARCHED_LAYERS',
    layer,
  };
}

export function setPredefinedLayer(type, layer) {
  return {
    type: `SET_${type.toUpperCase()}_PREDEFINED_LAYER`,
    layer,
  };
}

export function addViewerCustomizations(customizations) {
  const viewerDefaults = {
    activeColor: '#f40000',
    backgroundColor: '#4a4a4a',
    logo: 'share/lois-logo.svg',
    landingPage: '',
    visibleSections: {
      buildings: true,
      sites: true,
      areas: true,
      folder: true,
    },
    activeOnLoad: 'buildings',
    searchOpen: '0',
    mapType: 'street',
    layers: [],
  };

  return {
    type: 'ADD_VIEWER_CUSTOMIZATIONS',
    customizations: {
      ...viewerDefaults,
      ...customizations,
    },
  };
}

export function captureViewportInfo(viewport) {
  return {
    type: 'CAPTURE_VIEWPORT_INFO',
    viewport,
  };
}

export function setActiveTab(section, activeTab) {
  return {
    type: 'ACTIVE_TAB',
    section,
    activeTab,
  };
}

export function updateFilterAndActivateList(area, filters, isMobile, organizationId) {
  return dispatch => {
    const params = [...filters].reduce((obj, filter) => {
      return {
        ...obj,
        [filter[0]]: filter[1],
      };
    }, {});
    const parameters = { find: JSON.stringify(params) };
    dispatch(fetchBuildings(organizationId, parameters));
    if (isMobile) {
      dispatch(setActiveTab(area, 'tab-list'));
    }
  };
}

export function updateProperties(
  propertyType,
  filters,
  sort,
  organizationId,
  page,
  previouslySearchedLayer,
) {
  return dispatch => {
    let modifiedFilters = null;
    if (filters.has('shapefile')) {
      modifiedFilters = new Map([...filters, ['shapefile', filters.get('shapefile').arcId]]);
    }
    dispatch(updateFilter(propertyType, filters));
    dispatch(handleSort(propertyType, sort));
    if (filters.has('shapefile')) {
      dispatch(setSearchCustomLayer(filters.get('shapefile')));
      dispatch(setSearchCustomLayerForPropertyType(propertyType, filters.get('shapefile'), previouslySearchedLayer));
    } else if (!filters.has('shapefile') && _.get(previouslySearchedLayer, 'arcId', null)) {
      dispatch(setSearchCustomLayerForPropertyType(propertyType, filters.get('shapefile'), previouslySearchedLayer));
    }
    const search = JSON.stringify(filters.get('search'));

    const parameters = {
      find: filtersToFindParam(modifiedFilters || filters),
      sort: sortToParam(sort),
      search,
      page,
    };
    const fetcher = propertyType === 'buildings' ? fetchBuildings : fetchSites;
    return dispatch(fetcher(organizationId, parameters, page));
  };
}

export function fetchBuilding(id, isMobile, orgId) {
  return dispatch => {
    return getBuilding(id, orgId)
      .then(data => {
        dispatch(addActiveBuilding(data));
        if (isMobile) {
          dispatch(setActiveTab('buildings', 'tab-detail'));
        }
        return data;
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return [];
      });
  };
}

export function selectDemographicsLevel(level) {
  return {
    type: 'SELECT_DEMOGRAPHICS_LEVEL',
    level,
  };
}

export function setNaicsCode(type, naicsCode, businesses) {
  return {
    type: `SET_${type.toUpperCase()}_NAICS_CODE`,
    naicsCode,
    businesses,
  };
}

export function setNaicsCodeError(type, naicsCode, { error }) {
  return {
    type: `SET_${type.toUpperCase()}_NAICS_CODE_ERROR`,
    naicsCode,
    error,
  };
}

export function loadingNaicsCode(type, naicsCode) {
  return {
    type: `LOADING_${type.toUpperCase()}_NAICS_CODE`,
    naicsCode,
  };
}

export function saveSearchedItems(searchedItems) {
  return {
    type: 'SAVE_SEARCHED',
    searchedItems,
  };
}

export function restorePredefinedMapLayers(propertyType) {
  return (dispatch, state) => {
    const { viewer: { layers: { default: defaultLayers = [] } = {} } } = state();
    const isLayerActiveByDefault = layer => {
      const key = layer.replace(' ', '').toLowerCase();
      return defaultLayers && defaultLayers[key] === 2;
    };
    const predefinedLayers = Object.keys(railroads).reduce((pl, layer) => {
      if (isLayerActiveByDefault(layer)) {
        pl.push(layer);
      }
      return pl;
    }, []);
    dispatch(setPredefinedLayer(propertyType, predefinedLayers));
  };
}

export function resetMap(layersActive, propertyType) {
  return (dispatch, state) => {
    if (!layersActive) {
      return;
    }
    const { organizationId, saveSearchedLayers } = state();
    dispatch(activateMapLoadingStatus());
    document.querySelector('.map-wrapper').style.cursor = 'not-allowed';
    setTimeout(() => {
      dispatch(clearFilters(propertyType));
      dispatch(removeFilterDrawnLayer(propertyType));
      dispatch(
        updateProperties(
          propertyType,
          state()[propertyType].filters,
          state()[propertyType].sort,
          organizationId,
          undefined,
          saveSearchedLayers,
        ),
      );
      dispatch(deactivateMeasure());
      dispatch({ type: `RESET_${propertyType.toUpperCase()}_MAP` });
      dispatch({ type: `SET_${propertyType.toUpperCase()}_CUSTOM_LAYER` });
      dispatch(setNaicsCode(propertyType, null, null));
      dispatch(restorePredefinedMapLayers(propertyType));
      dispatch(deactivateMapLoadingStatus());
      document.querySelector('.map-wrapper').style.cursor = 'default';
    }, 200);
  };
}

// --- Analysis Pin Actions ---
export function activateAnalysisPinMode() {
  return {
    type: 'ACTIVATE_ANALYSIS_PIN_MODE',
  };
}

export function deactivateAnalysisPinMode() {
  return {
    type: 'DEACTIVATE_ANALYSIS_PIN_MODE',
  };
}

export function setAnalysisPinLocation(latLng) {
  // latLng should be an object like { lat: Number, lng: Number }
  return {
    type: 'SET_ANALYSIS_PIN_LOCATION',
    payload: latLng,
  };
}

export function clearAnalysisPinLocation() {
  return {
    type: 'CLEAR_ANALYSIS_PIN_LOCATION',
  };
}
// --- End Analysis Pin Actions ---

export function setSites(propertyType, sites) {
  return {
    type: 'SET_SITES',
    propertyType,
    sites,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions.js